// EventsPage.jsx

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Divider,
  ButtonBase,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Navbar from 'scenes/widgets/navbar';
import Footer from 'scenes/widgets/footer';
import PopupWidget from 'scenes/widgets/PopupWidget.jsx';
import DIVIDER_SVG from 'scenes/widgets/Divider_SVG.jsx';
import KKM_SVG from 'scenes/widgets/KKM_SVG';
import EventsPopupWidget from 'scenes/widgets/EventsPopupWidget';
import './styles.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Autoplay } from 'swiper/modules';

const slidesData = [
  {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 07. AUGUST 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    cta: 'ANSEHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/events/1',
    color: '#60ade1',
    content: 'Event content 2',
    arrowFills: ['#854d74', '#c796b7', '#8e1861'],
    date: '2025-08-07T16:00:00',
    month: 8
  },
  {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 14. AUGUST 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    cta: 'ANSEHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/events/1',
    color: '#e88527',
    content: 'Event content 3',
    arrowFills: ['#b39618', '#f2e198', '#e2cb4d'],
    date: '2025-08-14T16:00:00',
  },
  {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 21. AUGUST 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    cta: 'HIER BUCHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/events/1',
    color: '#f2e198',
    content: 'TREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    arrowFills: ['#1a5e7d', '#2074b8', '#60ade1'],
    date: '2025-08-21T16:00:00',
  },
  {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 28. AUGUST 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    cta: 'HIER BUCHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/events/1',
    color: '#60ade1',
    content: 'Event content 2',
    arrowFills: ['#854d74', '#c796b7', '#8e1861'],
    date: '2025-08-28T16:00:00',
  },
  {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 04. SEPTEMBER 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    cta: 'HIER BUCHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/events/1',
    color: '#e88527',
    content: 'Event content 3',
    arrowFills: ['#b39618', '#f2e198', '#e2cb4d'],
    date: '2025-09-04T16:00:00',
    month: 9
  },
  {
    image: '/assets/events/slider/EventBus.png',
    title: 'Event Bus',
    sub: 'DONNERSTAG, 04. SEPTEMBER 2025\nIDA EHRE SCHULE\n\nUNSER EVENT-BUS BRINGT KREATIVITÄT DIREKT ZU DEN KINDERN. IN DER NÄHE VON SCHULEN UND AN VERSCHIEDENEN STANDORTEN KÖNNEN SIE IHRE EIGENEN KALEIDOSKOPE GESTALTEN, SPASS HABEN UND AM WETTBEWERB TEILNEHMEN. SO ENTSTEHEN EINZIGARTIGE KUNSTWERKE UND VIELE STRAHLENDE GESICHTER.',
    cta: 'ANSEHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/events/1',
    color: '#e88527',
    content: 'Event content 3',
    arrowFills: ['#b39618', '#f2e198', '#e2cb4d'],
    date: '2025-09-04T16:00:01',
  },
  {
    image: '/assets/events/slider/EventBus.png',
    title: 'Event Bus',
    sub: 'DONNERSTAG, 11. SEPTEMBER 2025\nGYMNASIUM KLOSTERSCHULE\n\nUNSER EVENT-BUS BRINGT KREATIVITÄT DIREKT ZU DEN KINDERN. IN DER NÄHE VON SCHULEN UND AN VERSCHIEDENEN STANDORTEN KÖNNEN SIE IHRE EIGENEN KALEIDOSKOPE GESTALTEN, SPASS HABEN UND AM WETTBEWERB TEILNEHMEN. SO ENTSTEHEN EINZIGARTIGE KUNSTWERKE UND VIELE STRAHLENDE GESICHTER.',
    cta: 'ANSEHEN',
    ctaDetail: 'BUS FINDEN',
    path: 'https://www.instagram.com/kunstkaleidoskop/',
    color: '#e88527',
    content: 'Event content 3',
    arrowFills: ['#b39618', '#f2e198', '#e2cb4d'],
    date: '2025-09-11T16:00:00',
  },
  {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 11. SEPTEMBER 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    cta: 'HIER BUCHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/kontakt',
    color: '#e88527',
    content: 'Event content 3',
    arrowFills: ['#b39618', '#f2e198', '#e2cb4d'],
    date: '2025-09-11T16:00:01',
  },
  {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 18. SEPTEMBER 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
    cta: 'HIER BUCHEN',
    ctaDetail: 'JETZT EINTRAGEN',
    path: '/kontakt',
    color: '#e88527',
    content: 'Event content 3',
    arrowFills: ['#b39618', '#f2e198', '#e2cb4d'],
    date: '2025-09-18T16:00:00',
  },
  {
    image: '/assets/events/slider/EventBus.png',
    title: 'Event Bus',
    sub: 'DONNERSTAG, 25. SEPTEMBER 2025\nLUISEN-GYMNASIUM BERGEDORF\n\nUNSER EVENT-BUS BRINGT KREATIVITÄT DIREKT ZU DEN KINDERN. IN DER NÄHE VON SCHULEN UND AN VERSCHIEDENEN STANDORTEN KÖNNEN SIE IHRE EIGENEN KALEIDOSKOPE GESTALTEN, SPASS HABEN UND AM WETTBEWERB TEILNEHMEN. SO ENTSTEHEN EINZIGARTIGE KUNSTWERKE UND VIELE STRAHLENDE GESICHTER.',
    cta: 'ANSEHEN',
    ctaDetail: 'BUS FINDEN',
    path: 'https://www.instagram.com/kunstkaleidoskop/',
    color: '#e88527',
    content: 'Event content 3',
    arrowFills: ['#b39618', '#f2e198', '#e2cb4d'],
    date: '2025-09-25T16:00:00',
  },
];

const LeftArrow = ({ fills }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 527 864"
    style={{ width: '100%', height: '100%' }}
  >
    <defs>
      <style>
        {`
          .cls-1 { fill: ${fills[0]}; }
          .cls-2 { fill: ${fills[1]}; }
          .cls-3 { fill: ${fills[2]}; }
        `}
      </style>
    </defs>
    <path
      className="cls-3"
      d="M376.17,402.24c-7.39-.18-83.43-184.7-79.49-197.33,3.93-12.65,219.84-207.26,228.22-204.89,8.38,2.37-141.33,402.4-148.72,402.22Z"
    />
    <path
      className="cls-1"
      d="M376.67,491.63c6.31-1.52,157.61,367.81,149.76,371.84-7.84,4.03-220.02-162.68-223.16-173.33-3.14-10.65,67.11-196.99,73.4-198.5Z"
    />
    <path
      className="cls-2"
      d="M352.95,448.18c-.04,11.7-77.31,220.16-82.85,223.77-5.53,3.59-270.11-189.13-270.11-209.81,0-21.27,257.5-238.68,263.35-236.45,5.86,2.23,89.64,210.8,89.6,222.5Z"
    />
  </svg>
);

const RightArrow = ({ fills }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 527 864"
    style={{ width: '100%', height: '100%' }}
  >
    <defs>
      <style>
        {`
          .cls-1 { fill: ${fills[0]}; }
          .cls-2 { fill: ${fills[1]}; }
          .cls-3 { fill: ${fills[2]}; }
        `}
      </style>
    </defs>
    <path
      className="cls-3"
      d="M150.56,402.24c7.39-.18,83.43-184.7,79.49-197.33C226.12,192.25,10.22-2.35,1.84.02c-8.38,2.37,143.17,402.4,150.72,402.22Z"
    />
    <path
      className="cls-1"
      d="M150.05,491.63c-6.31-1.52-157.61,367.81-149.76,371.84,7.84,4.03,220.02-162.68,223.16-173.33,3.14-10.65-67.11-196.99-73.4-198.5Z"
    />
    <path
      className="cls-2"
      d="M173.77,448.18c.04,11.7,77.31,220.16,82.85,223.77,5.53,3.59,270.11-189.13,270.11-209.81,0-21.27-257.5-238.68-263.35-236.45-5.86,2.23-89.64,210.8-89.6,222.5Z"
    />
  </svg>
);

const arrowColorSets = [
  ['#1a5e7d', '#2074b8', '#60ade1'],
  ['#854d74', '#c796b7', '#8e1861'],
  ['#b39618', '#f2e198', '#e2cb4d']
];

const getCurrentTimeInGermany = () => {
  return new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" });
};

const processSlides = (slides) => {
  const now = new Date(getCurrentTimeInGermany());

  const processedSlides = slides.map(slide => ({
    ...slide,
    isCurrent: new Date(slide.date) >= now
  }));

  const currentEvents = processedSlides
    .filter(slide => slide.isCurrent)
    .sort((a, b) => new Date(a.date) - new Date(b.date)); 

  const pastEvents = processedSlides
    .filter(slide => !slide.isCurrent)
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  return [...currentEvents, ...pastEvents];
};

const getInitialSlideIndex = (slides) => {
  return 0;
};

const EventsPage = () => {
  const theme = useTheme();
  const isNonMobileScreens = useMediaQuery('(min-width:1000px)');
  const isEventsMobile = useMediaQuery('(min-width:1200px)');

  const processedSlides = processSlides(slidesData);
  const initialSlideIndex = getInitialSlideIndex(processedSlides);
  
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(initialSlideIndex);
  const [selectedEventIndex, setSelectedEventIndex] = useState(initialSlideIndex);
  const [sectionIndex, setSectionIndex] = useState(0);
  const [arrowColorIndex, setArrowColorIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [detailSwiperInstance, setDetailSwiperInstance] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState(null);
  const months = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
  ];

  const getSlideMonth = (slide) => {
    if (slide.date) {
      return new Date(slide.date).getMonth() + 1;
    }

    if (slide.month) {
      return slide.month;
    }

    const dateMatch = slide.sub.match(/\d{1,2}\.\s*([A-ZÜÄÖ]+)\s*\d{4}/i);
    if (dateMatch) {
      const monthName = dateMatch[1].toUpperCase();
      const monthMap = {
        'JANUAR': 1, 'FEBRUAR': 2, 'MÄRZ': 3, 'APRIL': 4,
        'MAI': 5, 'JUNI': 6, 'JULI': 7, 'AUGUST': 8,
        'SEPTEMBER': 9, 'OKTOBER': 10, 'NOVEMBER': 11, 'DEZEMBER': 12
      };
      return monthMap[monthName] || null;
    }
    return null;
  };

  const handleMonthClick = (monthIndex) => {
    const targetMonth = monthIndex + 1;

    if (selectedMonth === monthIndex) {
      setSelectedMonth(null);
      if (swiperInstance) {
        swiperInstance.slideToLoop(0);
        setActiveIndex(0);
      }
      return;
    }

    setSelectedMonth(monthIndex);

    const slideIndex = processedSlides.findIndex(slide => getSlideMonth(slide) === targetMonth);

    if (slideIndex !== -1 && swiperInstance) {
      swiperInstance.slideToLoop(slideIndex);
      setActiveIndex(slideIndex);
    }
  };

  return (
    <Box>
      <Navbar />      

      {/* SECTION 1 */}
      <Box
        sx={{
          top: { xs: '-114px', sm: '-114px', md: '-103px' },
          position: 'relative',
          backgroundImage: "url('/assets/events/Eventheader.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100vw',
          aspectRatio: 1920 / 540,
          marginLeft: 'calc(50% - 50vw)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          marginBottom: '-100px'
        }}
      >

      </Box>

      <Typography
        variant="h1"
        sx={{
          left: isEventsMobile ? undefined : "0px",
          bottom: '20px',
          padding: '20px',
          width: isEventsMobile ? '1200px' : undefined,
          margin: isEventsMobile ? '0 auto' : undefined,
          display: 'flex',
          justifyContent: 'center',
          fontSize: '4rem',
          marginTop: '60px',
        }}
      >
        Events
      </Typography>

      <Typography
        variant="h1"
        sx={{
          left: isEventsMobile ? undefined : "0px",
          bottom: '20px',
          padding: '20px',
          width: isEventsMobile ? '1200px' : undefined,
          margin: isEventsMobile ? '0 auto' : undefined,
          display: 'flex',
          justifyContent: 'center',
          fontSize: '2rem',
          marginTop: '40px',
          marginBottom: '80px',
          textAlign: 'center'
        }}
      >
        Mach du dein´Job, wir machen den Rest!
      </Typography>

      {/* Swiper Start */}
      <Box
        sx={{
          maxWidth: isEventsMobile ? '1200px' : '100%',
          margin: '0 auto',
          marginBottom: '4rem',
          position: 'relative',
        }}
      >
        <Swiper
          modules={[Navigation]}
          grabCursor
          slidesPerView={isEventsMobile ? 3 : 1.5}
          loop
          centeredSlides={true}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          onSwiper={(swiper) => setSwiperInstance(swiper)}
          breakpoints={{
            320: {
              spaceBetween: 10,
            },
            768: {
              spaceBetween: 30,
            },
            1024: {
              spaceBetween: 50,
            },
          }}
        >
          {processedSlides.map((slide, idx) => (
            <SwiperSlide
              key={idx}
              style={{
                width: isNonMobileScreens ? '300px' : '250px',
              }}
            >
              {({ isActive }) => (
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    aspectRatio: '1/1',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    margin: '0 auto',
                    transform: isActive ? 'scale(1.0)' : 'scale(0.9)',
                    transition: 'transform 0.3s ease',
                    filter: slide.isCurrent ? 'none' : 'grayscale(100%)',
                  }}
                  onClick={() => {
                    setSelectedEventIndex(idx);
                    if (detailSwiperInstance) {
                      detailSwiperInstance.slideToLoop(idx);
                    }
                    setTimeout(() => {
                      const detailSection = document.getElementById('event-details');
                      if (detailSection) {
                        detailSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                >
                  {/* Slide Image */}
                  <Box
                    component="img"
                    src={slide.image}
                    alt={slide.title}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />

                  {/* Dark Overlay on Hover */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(0, 0, 0, 0.7)',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      opacity: 0,
                      transition: 'opacity 0.3s ease',
                      '&:hover': {
                        opacity: 1,
                      },
                    }}
                  >
                    {/* Header */}
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'left',
                        whiteSpace: 'pre-line',
                        fontSize: { xs: '1.2rem', md: '1.5rem' },
                        mt: 2,
                        ml: 2,
                      }}
                    >
                      {slide.title}
                    </Typography>

                    {/* Subtext */}
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'white',
                        textAlign: 'left',
                        fontStyle: 'italic',
                        fontWeight: 'bold',
                        fontSize: { xs: '0.9rem', md: '0.9rem' },
                        ml: 2,
                        whiteSpace: 'pre-line',
                      }}
                    >
                      {slide.sub}
                    </Typography>

                    {/* Underlined Button Text */}
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'white',
                        textAlign: 'center',
                        textDecoration: slide.isCurrent ? 'underline' : 'none',
                        fontSize: { xs: '1rem', md: '1.2rem' },
                        fontWeight: 'bold',
                        mb: 2,
                        ml: 2,
                      }}
                    >
                      {slide.isCurrent ? slide.cta : ''}
                    </Typography>
                  </Box>
                </Box>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Custom Prev Button */}
        <Box
          className="swiper-button-prev"
          onClick={() => setArrowColorIndex((prev) => (prev + 1) % arrowColorSets.length)}
          sx={{
            position: 'absolute',
            left: { xs: '-40px', md: '-100px' },
            top: '50%',
            zIndex: 10,
            cursor: 'pointer',
            display: isEventsMobile ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: '30px', md: '60px' },
            height: { xs: '30px', md: '60px' },
            '&::after': { display: 'none' },
          }}
        >
          <LeftArrow fills={arrowColorSets[arrowColorIndex]} />
        </Box>

        {/* Custom Next Button */}
        <Box
          className="swiper-button-next"
          onClick={() => setArrowColorIndex((prev) => (prev + 1) % arrowColorSets.length)}
          sx={{
            position: 'absolute',
            right: { xs: '-40px', md: '-100px' },
            top: '50%',
            zIndex: 10,
            cursor: 'pointer',
            display: isEventsMobile ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: '30px', md: '60px' },
            height: { xs: '30px', md: '60px' },
            '&::after': { display: 'none' },
          }}
        >
          <RightArrow fills={arrowColorSets[arrowColorIndex]} />
        </Box>
      </Box>
      {/* Swiper End */}

      {/* Month Filter */}
      <Box
        sx={{
          margin: '40px auto',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div className="month-filter">
          {months.map((month, index) => (
            <button
              key={index}
              className={`month-item ${selectedMonth === index ? 'active' : ''}`}
              onClick={() => handleMonthClick(index)}
              style={{
                borderRadius: window.innerWidth <= 768 ? '15px' :
                  index === 0 ? '25px 0 0 25px' :
                    index === 11 ? '0 25px 25px 0' : '0',
              }}
            >
              {month}
            </button>
          ))}
        </div>
      </Box>

      {/* Some text below the background image */}
      <Box
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: isEventsMobile ? '0px' : '20px'
        }}
      >
        <Typography variant="body1" sx={{ mb: 2}}>
          Als Partner setzen wir deine Events um – ob Schulung, Team-Event oder Präsentation. Du bestimmst das Thema, den Stil und sogar den Ort: Ob in unserer Business-Galerie oder an einem Veranstaltungsort deiner Wahl – wir sorgen für den passenden Rahmen. So entsteht Raum für Austausch, Sichtbarkeit und echten Mehrwert – für dich, dein Team und deine Kunden.
        </Typography>
        {/* Button as Image with Text Overlay */}
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', marginTop: '20px' }}>
          <Box
            component={RouterLink}
            to="/kontakt"
            sx={{
              cursor: 'pointer',
              maxWidth: '228.5px',
              position: 'relative',
              display: 'inline-block',
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.1)',
              },
            }}
          >
            <Box
              component="img"
              src="/assets/misc/Button.png"
              alt="Jetzt eintragen"
              sx={{
                width: '100%',
                height: 'auto',
                display: 'block',
                pointerEvents: 'none',
              }}
            />
            <Typography
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: 'white',
                fontFamily: 'Montserrat',
                fontStyle: 'italic',
                fontWeight: 'bold',
                textAlign: 'center',
                pointerEvents: 'none',
                fontSize: '1.2rem',
                whiteSpace: 'nowrap',
                width: '90%',
              }}
            >
              JETZT ANFRAGEN
            </Typography>
          </Box>
        </Box>

      </Box>

      {/* Event Detail Swiper */}
      <Box
        id="event-details"
        sx={{
          maxWidth: { xs: '90%', md: '1200px' },
          margin: '60px auto',
          position: 'relative',
          scrollMarginTop: '140px',
        }}
      >
        <Swiper
          modules={[Navigation]}
          grabCursor
          slidesPerView={1}
          loop
          spaceBetween={0}
          initialSlide={selectedEventIndex}
          navigation={{
            prevEl: '.detail-swiper-button-prev',
            nextEl: '.detail-swiper-button-next',
          }}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          onSwiper={(swiper) => setDetailSwiperInstance(swiper)}
        >
          {processedSlides.map((slide, idx) => (
            <SwiperSlide key={idx}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: 'center',
                  minHeight: '400px',
                  gap: 4,
                }}
              >
                {/* Left Half - Image */}
                <Box
                  sx={{
                    width: { xs: '100%', md: '50%' },
                  }}
                >
                  <Box
                    component="img"
                    src={slide.image}
                    alt={slide.title}
                    sx={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      aspectRatio: '1/1',
                      filter: slide.isCurrent ? 'none' : 'grayscale(100%)'
                    }}
                  />
                </Box>

                {/* Right Half - Content */}
                <Box
                  sx={{
                    width: { xs: '100%', md: '50%' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    textAlign: 'left',
                    padding: '1rem',
                    gap: 4
                  }}
                >
                  {/* Title */}
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 'bold',
                      whiteSpace: 'pre-line',
                      fontSize: { xs: '2rem', md: '3rem' },
                    }}
                  >
                    {slide.title}
                  </Typography>

                  {/* Subtext */}
                  <Typography
                    variant="h5"
                    sx={{
                      color: 'text.secondary',
                      fontSize: { xs: '1.2rem', md: '1.5rem' },
                      fontStyle: 'italic',
                      fontWeight: 'normal',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {slide.sub}
                  </Typography>

                  {/* Jetzt Buchen Button */}
                  {slide.isCurrent ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Box
                        component={slide.path.startsWith('http') ? 'a' : RouterLink}
                        to={slide.path.startsWith('http') ? undefined : slide.path}
                        href={slide.path.startsWith('http') ? slide.path : undefined}
                        target={slide.path.startsWith('http') ? '_blank' : undefined}
                        rel={slide.path.startsWith('http') ? 'noopener noreferrer' : undefined}
                        sx={{
                          cursor: 'pointer',
                          maxWidth: '228.5px',
                          position: 'relative',
                          display: 'inline-block',
                          transition: 'transform 0.3s ease',
                          '&:hover': {
                            transform: 'scale(1.1)',
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src="/assets/misc/Button.png"
                          alt={slide.ctaDetail}
                          sx={{
                            width: '100%',
                            height: 'auto',
                            display: 'block',
                            pointerEvents: 'none',
                          }}
                        />
                        <Typography
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: 'white',
                            fontFamily: 'Montserrat',
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            pointerEvents: 'none',
                            fontSize: '1.2rem',
                            whiteSpace: 'nowrap',
                            width: '90%',
                          }}
                        >
                          {slide.ctaDetail}
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        width: { xs: '180px', md: '250px' },
                        height: { xs: '40px', md: '60px' },
                      }}
                    />
                  )}
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Detail Swiper Custom Prev Button */}
        <Box
          className="detail-swiper-button-prev"
          onClick={() => setArrowColorIndex((prev) => (prev + 1) % arrowColorSets.length)}
          sx={{
            position: 'absolute',
            left: { xs: '-40px', md: '-100px' },
            top: '50%',
            zIndex: 10,
            cursor: 'pointer',
            display: isEventsMobile ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: '30px', md: '60px' },
            height: { xs: '30px', md: '60px' },
            '&::after': { display: 'none' },
          }}
        >
          <LeftArrow fills={arrowColorSets[arrowColorIndex]} />
        </Box>

        {/* Detail Swiper Custom Next Button */}
        <Box
          className="detail-swiper-button-next"
          onClick={() => setArrowColorIndex((prev) => (prev + 1) % arrowColorSets.length)}
          sx={{
            position: 'absolute',
            right: { xs: '-40px', md: '-100px' },
            top: '50%',
            zIndex: 10,
            cursor: 'pointer',
            display: isEventsMobile ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: '30px', md: '60px' },
            height: { xs: '30px', md: '60px' },
            '&::after': { display: 'none' },
          }}
        >
          <RightArrow fills={arrowColorSets[arrowColorIndex]} />
        </Box>
      </Box>



      {/* Divider / SVG to transition to Section 2 */}
      <Box sx={{ my: 4, width: "100vw", overflowX: "hidden" }}>
        <DIVIDER_SVG />
      </Box>

      {/* New Afterwork Images Section */}
      <Box sx={{ mt: { xs: '20px', sm: '200px', md: '200px' } }}>
        {/* Afterwork Text Cover */}
        <Box id="afterwork" sx={{
          mt: '80px', mb: { xs: 0, md: '40px' },
          scrollMarginTop: { xs: '90px', sm: '100px', md: '120px' },
        }}>
          <img
            src="/assets/events/Text_Afterwork.svg"
            alt="Afterwork Text Cover"
            style={{ width: '100%', display: 'block', zIndex: 5 }}
          />
        </Box>
      </Box>

      <Typography
        variant="h1"
        sx={{
          left: isEventsMobile ? undefined : "0px",
          bottom: '20px',
          padding: '20px',
          width: isEventsMobile ? '1200px' : undefined,
          margin: isEventsMobile ? '0 auto' : undefined,
          display: 'flex',
          justifyContent: 'center',
          fontSize: isEventsMobile ? '4rem' : '1.6rem',
          marginTop: isEventsMobile ? '160px' : '40px',
          textAlign: 'center'
        }}
      >
        Jeden Donnerstag ab 16 Uhr
      </Typography>

      {/* Afterwork Description Text */}
      <Box sx={{ maxWidth: '800px', mx: 'auto', px: isEventsMobile ? '0px' : '20px', mb: 12, mt: isEventsMobile ? '120px' : '30px' }}>
        <Typography variant="body1" paragraph>
          Jeden Donnerstag ab 16 Uhr öffnen wir die Türen im Cremon 11.<br />
          Unternehmer, Künstler und Interessierte treffen hier in entspannter Atmosphäre zusammen. Unser Afterwork ist die Gelegenheit, Kunst zu entdecken, neue Kontakte zu knüpfen und sich über aktuelle Projekte und Ideen auszutauschen.
          <br /><br />
          Dich erwarten inspirierende Gespräche, leckeres Essen und erfrischende Getränke – der perfekte Rahmen, um den Tag gemeinsam ausklingen zu lassen und Anregungen für neue Vorhaben mitzunehmen.
          <br /><br />
          Komm vorbei, bring gerne Kollegen oder Geschäftspartner mit und erlebe echten Austausch mitten in Hamburgs Innenstadt.
        </Typography>
      </Box>

      {/* Button as Image with Text Overlay */}
      <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', marginTop: '20px' }}>
        <Box
          component={RouterLink}
          to="/kontakt"
          sx={{
            cursor: 'pointer',
            maxWidth: '228.5px',
            position: 'relative',
            display: 'inline-block',
            transition: 'transform 0.3s ease',
            '&:hover': {
              transform: 'scale(1.1)',
            },
          }}
        >
          <Box
            component="img"
            src="/assets/misc/Button.png"
            alt="Jetzt eintragen"
            sx={{
              width: '100%',
              height: 'auto',
              display: 'block',
              pointerEvents: 'none',
            }}
          />
          <Typography
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: 'white',
              fontFamily: 'Montserrat',
              fontStyle: 'italic',
              fontWeight: 'bold',
              textAlign: 'center',
              pointerEvents: 'none',
              fontSize: '1.2rem',
              whiteSpace: 'nowrap',
              width: '90%',
            }}
          >
            Gutschein sichern!
          </Typography>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};

export default EventsPage;